import { ComponentProps } from "react";

import { useThemeProvider } from "@providers/ThemeProvider/useThemeProvider";

import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Option, Select } from "@design-system/Select/Select";

const THEME_OPTIONS: Option[] = [
  { id: "light", label: "Light" },
  { id: "dark", label: "Dark" },
];

export const ThemeSelect = () => {
  const { isDarkMode, setTheme } = useThemeProvider();

  const handleChange: ComponentProps<typeof Select>["onChange"] = (value) => {
    setTheme(value === "dark" ? "dark" : "light");
  };

  return (
    <FieldGroup label="Theme">
      <Select
        options={THEME_OPTIONS}
        value={isDarkMode ? "dark" : "light"}
        onChange={handleChange}
      />
    </FieldGroup>
  );
};
